import React, { useState } from 'react';

function Thanks() {
  return (
    <div className="container block is-max-desktop">
      <div className="container block">
        <h3 className="has-text-weight-bold is-size-3 honey-text-font-family-common honey-text-common">
          Thank You!
        </h3>
      </div>
      <h5 className="has-text-weight-bold is-size-5 honey-text-font-family-common honey-text-common">
        An email with the key was sent to the provided email.
      </h5>
    </div>
  );
}

export default Thanks;
